export class Accordion {
    InitialiseAccordions() {
        const accordions = document.querySelectorAll(".accordion");
        accordions.forEach(e => e.addEventListener("click", function () {
            /* Toggle between adding and removing the "active" class,
              to highlight the button that controls the panel */
            e.classList.toggle("active");
        }));
    }
}
;
